import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { LanguageProvider } from "@/context/LanguageContext";
import { AuthProvider } from "@/context/AuthContext";
import { Layout } from "@/components/Layout";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { CookieBanner } from "@/components/CookieBanner";
import { FaqChat } from "@/components/FaqChat";
import { WebMCP } from "@/components/WebMCP";

import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Scanner from "@/pages/Scanner";
import Evidence from "@/pages/Evidence";
import ConditionPublic from "@/pages/ConditionPublic";
import Stack from "@/pages/Stack";
import Formula from "@/pages/Formula";
import Pricing from "@/pages/Pricing";
import Profile from "@/pages/Profile";
import Community from "@/pages/Community";
import SubscriptionSuccess from "@/pages/SubscriptionSuccess";
import SubscriptionCancel from "@/pages/SubscriptionCancel";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";

const Protected = ({ children }) => <ProtectedRoute>{children}</ProtectedRoute>;

function App() {
  return (
    <LanguageProvider>
      <AuthProvider>
        <BrowserRouter>
          <Toaster position="top-center" richColors />
          <Layout>
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route path="/scan" element={<Scanner />} />
              <Route path="/evidence" element={<Evidence />} />
              <Route path="/condition/:slug" element={<ConditionPublic />} />
              <Route path="/library" element={<Navigate to="/evidence" replace />} />
              <Route path="/stack" element={<Protected><Stack /></Protected>} />
              <Route path="/pubmed" element={<Navigate to="/evidence" replace />} />
              <Route path="/formula" element={<Protected><Formula /></Protected>} />
              <Route path="/community" element={<Protected><Community /></Protected>} />
              <Route path="/profile" element={<Protected><Profile /></Protected>} />
              <Route path="/pricing" element={<Pricing />} />
              <Route path="/subscription/success" element={<SubscriptionSuccess />} />
              <Route path="/subscription/cancel" element={<SubscriptionCancel />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/terms" element={<Terms />} />
            </Routes>
          </Layout>
          <CookieBanner />
          <FaqChat />
          <WebMCP />
        </BrowserRouter>
      </AuthProvider>
    </LanguageProvider>
  );
}

export default App;
